import { eventBus, dom, common } from '@mtfe/sweet-utils';
import { Tabs, WelfareCard, componentUtils } from '@mtfe/sweet-components';

import store, { storeRecallBizIdMap } from '../../store/index';
import InnerPoi from '../common/InnerPoi/script';
import { renderPoiInfoGWithCoupon } from '../../utils/renderPoi';
import { fetchAndDispatchDataToStore } from '../../utils/fetchData';

const { storeCommon } = store;

const { createUniqueId } = common;
const { getOnClickEventName } = componentUtils;

const SelfCouponComponent = async (welfareArr) => {
    const { dom_wm_self_coupon: domWmSelfCoupon } = storeCommon.structInfo.struct;
    const storeWmSelfCouponAll = store[domWmSelfCoupon.recallBizId];
    const storeWmSelfCoupon = store[storeRecallBizIdMap.wmSelfCoupon];

    const { poiData } = storeWmSelfCouponAll;
    const { tabsInfo } = storeWmSelfCoupon;
    const selfContainer = dom.$id('selfContainer');

    try {
        await fetchAndDispatchDataToStore(storeWmSelfCouponAll);
        storeWmSelfCoupon.isShow = domWmSelfCoupon.isShow && poiData.poiList.length > 0;

        if (storeWmSelfCoupon.isShow) {
            const defaultActiveTabKey = domWmSelfCoupon.recallBizId;
            const tabs = Tabs({
                tabInfo: tabsInfo.map((item) => {
                    const { recallBizId } = item;
                    const resItem = { ...item, key: recallBizId, label: item.text };
                    resItem.innerComponent = InnerPoi({
                        poiData: store[recallBizId].poiData,
                        renderFunc: renderPoiInfoGWithCoupon,
                    });
                    return resItem;
                }),
                defaultActiveTabKey,
                onTabBarClick: (key) => {
                    const eventName = getOnClickEventName(key);
                    eventBus.$emit(eventName);
                },
                isSticky: false,
                theme: 'simple',
            });
            const subtitleID = createUniqueId();
            const welfareIndex = `福利${welfareArr.length + 1}`;
            const selfDom = WelfareCard({
                welfareIndex,
                title: '自选优惠券',
                innerComponent: tabs,
                subtitleID,
                isContainerGradient: true,
            });
            selfContainer.innerHTML = selfDom;
            eventBus.$on('selfCoupon-changeTimes', (times) => {
                const subtitleDom = dom.$id(subtitleID);
                if (subtitleDom) {
                    subtitleDom.innerHTML = `今日剩余领券次数：${times}`;
                }
            });
            eventBus.$emit(getOnClickEventName(defaultActiveTabKey));
        }
    } catch (error) {
        console.error(error);
    }
};

export default SelfCouponComponent;
